import React from 'react';
import TPGrid from 'components/TP-UI/TPGrid';
import { useTranslation } from 'react-i18next';
import { lettersWithSymbolsAndNumbers } from 'utils/normalizations';
import TPTypography from 'components/TP-UI/TPTypography';
import { Field } from 'redux-form';
import TPTextField from 'components/TP-UI/TPTextField';
import { checkNonLatin, required } from 'utils/validation/fieldValidationRules';
import PropTypes from 'prop-types';
import SendSms from '../../containers/SendSmsContainer';

const SmsCodeVerificationForm = ({
  phoneNumber,
  allowResend = true,
  sendCodeLabel = '',
  type,
  onCodeSent,
  onCodeExpired,
}) => {
  const { t } = useTranslation('auth');

  return (
    <TPGrid container spacing={2}>
      <TPGrid item xs={12}>
        <TPTypography variant="body1">
          {t('smsVerificationForm.smsCodeDescription', { phoneNumber })}
        </TPTypography>
      </TPGrid>
      <TPGrid item xs={12}>
        <Field
          component={TPTextField}
          fullWidth
          required
          name="code"
          label={t('smsVerificationForm.inputLabel')}
          placeholder={t('smsVerificationForm.inputPlaceholder')}
          type="text"
          validate={[checkNonLatin, required]}
          normalize={lettersWithSymbolsAndNumbers}
          hint={
            <TPTypography component="span" variant="body2">
              <SendSms
                label={sendCodeLabel || t('smsVerificationForm.resendCode.label')}
                timerLabel={t('smsVerificationForm.resendCode.timerLabel')}
                allowResend={allowResend}
                onCodeSent={onCodeSent}
                onExpire={onCodeExpired}
                type={type}
              />
            </TPTypography>
          }
        />
      </TPGrid>
    </TPGrid>
  );
};

SmsCodeVerificationForm.propTypes = {
  phoneNumber: PropTypes.string,
  allowResend: PropTypes.bool,
  sendCodeLabel: PropTypes.string,
  type: PropTypes.string,
  onCodeSent: PropTypes.func,
  onCodeExpired: PropTypes.func,
};

export default SmsCodeVerificationForm;
